module.exports = __webpack_public_path__ + "static/media/6967.a86d4010.jpg";